<template>
  <vs-dropdown v-if="show" vs-trigger-click>
    <vs-button class="btn-drop" type="filled" icon="expand_more"></vs-button>
    <vs-dropdown-menu>
      <vs-dropdown-item
        v-for="(termo,index) in termos"
        :key="index"
        target="_blank"
        :href="`${baseURL}/contratos/${$route.params.id}/termos/${termo.url}`"
      >{{ termo.nome }}</vs-dropdown-item>
    </vs-dropdown-menu>
  </vs-dropdown>
</template>
/termos
<script>
import { baseURL } from "@services/api-service";
export default {
  data() {
    return {
      show: false,
      termos: [],
      baseURL
    };
  },
  async created() {
    this.termos = await this.$store.getters.fetchTermos();
    this.show = true;
  }
};
</script>
